<template>
  <div>
    <top></top>
    <navMenu></navMenu>
    <div class="inner clearfix">
      <div class="indexworkleft fl">
        <indexfl></indexfl>
      </div>
      <div class="indexworkright fr">
        <indexfr></indexfr>
      </div>
    </div>
  </div>
</template>

<script>
import eventBus from "@/api/eventBus";
import "../../assets/work.css";
import top from "@/components/common/top.vue";
import navMenu from "@/components/common/navMenu.vue";
import indexfl from "../../components/work/indexfl.vue";
import indexfr from "../../components/work/indexfr.vue";

export default {
  name: "inde",
  data() {
    return {};
  },
  components: {
    indexfl,
    indexfr,
    top,
    navMenu,
  },
  created() {
    //发布作业跳转
    eventBus.$on("fabu", (val) => {
      // this.$router.push({
      //       name:'issuework',
      // })
    });
  },
  mounted() {},
  methods: {
    dataload() {
      // console.log("父组件")
    },
  },
};
</script>

<style scoped>
/* 初始化 */
body,
html,
div,
blockquote,
img,
label,
p,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
ul,
ol,
li,
dl,
dt,
dd,
form,
a,
fieldset,
input,
th,
td,
i,
em {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
}

.inner {
  margin-top: 15px;
}
.indexworkleft {
  padding: 10px 10px 0 0;
  margin-top: 15px;
}
.indexworkright {
  background: none;
}
</style>
